import { useEffect } from 'react';

import { httpService } from '@flexo/general';
import { useDispatch } from 'react-redux';
import { METADATA, ALERT } from '@flexo/reducers';


const ENV = (import.meta as any).env;

export const CommunitiesOverviewResolver = () => {

  const dispatch = useDispatch();

  async function init() {
    // Token auto-injected by httpService interceptor
    const [overview] = await Promise.all([
      httpService
        .get({
          url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_3/organization/${ENV.VITE_APP_ORG_ID}/overview`,
        })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data;
          } else {

            dispatch(ALERT.SetAlert({
              value: {
                type: 'BANNER_UNEXPECTED_ERROR'
              },
            } as any));

            return null;
          }
        })
        .catch((err: any) => {

          dispatch(ALERT.SetAlert({
            value: {
              type: 'BANNER_UNEXPECTED_ERROR'
            },
          } as any));

          return null;
        }),
    ]);

    dispatch(METADATA.SetCommunitiesOverview(overview));

  }

  useEffect(() => {
      init();
  }, []);

  return <></>;
};
